import { render, staticRenderFns } from "./MemberAccountMergerComponent.vue?vue&type=template&id=9fe5d706&scoped=true&"
import script from "./MemberAccountMergerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberAccountMergerComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberAccountMergerComponent.vue?vue&type=style&index=0&id=9fe5d706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe5d706",
  null
  
)

export default component.exports